module.exports = __webpack_public_path__ + "static/media/GED.65d6231e.png";